export default class ReferenceView {
	static STRING_VIEW_AND_REFERENCE_ID = 'STRING_VIEW_AND_REFERENCE_ID';
	static REFERENCE_ID = 'REFERENCE_ID';
	static STRING_VIEW = 'STRING_VIEW'
};
